import React from 'react';
import { call, takeEvery } from 'redux-saga/effects';
import showToast from '@/utils/toasts';
import ErrorToast from '@/components/toasts/ErrorToast';
import DeletesToast from '@/components/toasts/DeletesToast';
import UpdatedToast from '@/components/toasts/UpdatedToast';
import ErrorsToast from '@/components/toasts/ErrorsToast';
import actions from '../constants';
import DatasetAttachmentCreatedToast from '../components/DatasetAttachmentCreatedToast';

export function* deleteDatasetAttachmentErrorToast({ items }) {
  yield call(showToast, <ErrorsToast operation="actions.delete" errors={items} />);
}

export function* deleteDatasetAttachmentSuccessToast({ items }) {
  yield call(showToast, <DeletesToast items={items} />);
}

export function* updateDatasetAttachmentMetadataSuccess({ result: { name } }) {
  yield call(showToast, <UpdatedToast name={name} />);
}

export function* datasetAttachmentUploadSuccessToast({ code, name, file }) {
  yield call(showToast, <DatasetAttachmentCreatedToast code={code} name={name} filename={file.name} />);
}

export function* datasetAttachmentsUploadFailToast({ files }) {
  for (let i = 0; i < files.length; i++) {
    const file = files[i];
    yield call(showToast, <ErrorToast operation="actions.upload" name={file.name} />);
  }
}

export function* updateDatasetAttachmentMetadataError({ name }) {
  yield call(showToast, <ErrorToast operation="actions.update" name={name} />);
}

export function* datasetAttachmentDownloadErrorToast({ attachment }) {
  yield call(showToast, <ErrorToast operation="actions.download" name={attachment.name} />);
}

export default function* datasetAttachmentsToasts() {
  yield takeEvery(actions.DELETE_DATASET_ATTACHMENT_ERROR, deleteDatasetAttachmentErrorToast);
  yield takeEvery(actions.DELETE_DATASET_ATTACHMENT_SUCCESS, deleteDatasetAttachmentSuccessToast);
  yield takeEvery(actions.UPDATE_DATASET_ATTACHMENT_METADATA_SUCCESS, updateDatasetAttachmentMetadataSuccess);
  yield takeEvery(actions.DATASET_ATTACHMENT_UPLOAD_SUCCESS, datasetAttachmentUploadSuccessToast);
  yield takeEvery(actions.DATASET_ATTACHMENTS_UPLOAD_FAIL, datasetAttachmentsUploadFailToast);
  yield takeEvery(actions.UPDATE_DATASET_ATTACHMENT_METADATA_ERROR, updateDatasetAttachmentMetadataError);
  yield takeEvery(actions.DATASET_ATTACHMENT_DOWNLOAD_ERROR, datasetAttachmentDownloadErrorToast);
}
